/**
 * Formatea un importe del formato americano (5000.00) al formato argentino (5.000,00)
 * @param {string|number} importe - El importe a formatear
 * @returns {string} El importe formateado en formato argentino
 */
export function formatImporteToArgentino(importe) {
  if (!importe || importe === '') return '';
  
  // Convertir a string y limpiar
  const importeStr = String(importe).trim();
  
  // Si ya está en formato argentino, devolverlo tal como está
  if (importeStr.includes(',') && importeStr.includes('.')) {
    return importeStr;
  }
  
  // Convertir a número para asegurar formato correcto
  const numero = parseFloat(importeStr);
  
  if (isNaN(numero)) return '';
  
  // Formatear con separador de miles (punto) y decimales (coma)
  return numero.toLocaleString('es-AR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
}

/**
 * Convierte un importe del formato argentino (5.000,00) al formato americano (5000.00)
 * @param {string} importe - El importe en formato argentino
 * @returns {string} El importe en formato americano para enviar al backend
 */
export function formatImporteToAmericano(importe) {
  if (!importe || importe === '') return '';
  
  // Convertir a string y limpiar
  const importeStr = String(importe).trim();
  
  // Si ya está en formato americano, devolverlo tal como está
  if (!importeStr.includes(',') && importeStr.includes('.')) {
    return importeStr;
  }
  
  // Remover puntos (separadores de miles) y reemplazar coma por punto
  const numeroLimpio = importeStr
    .replace(/\./g, '') // Remover puntos (separadores de miles)
    .replace(',', '.'); // Reemplazar coma por punto (separador decimal)
  
  // Validar que sea un número válido
  const numero = parseFloat(numeroLimpio);
  
  if (isNaN(numero)) return '';
  
  // Retornar con formato americano (punto como separador decimal)
  return numero.toFixed(2);
}

/**
 * Valida si un importe tiene un formato válido (argentino o americano)
 * @param {string} importe - El importe a validar
 * @returns {boolean} True si el formato es válido
 */
export function isValidImporte(importe) {
  if (!importe || importe === '') return true; // Vacío es válido
  
  const importeStr = String(importe).trim();
  
  // Patrón para formato argentino: 1.234,56 o 1234,56
  const patronArgentino = /^\d{1,3}(\.\d{3})*,\d{2}$|^\d+,\d{2}$/;
  
  // Patrón para formato americano: 1234.56
  const patronAmericano = /^\d+\.\d{2}$/;
  
  // Patrón para números enteros
  const patronEntero = /^\d+$/;
  
  return patronArgentino.test(importeStr) || 
         patronAmericano.test(importeStr) || 
         patronEntero.test(importeStr);
}